const STRIPE_PAYMENT_PATH = /\/v2\/(one-step-check-out|payment-return)\/?$/
const CHECKOUT_FLOW_PATH = /\/v2\/(one-step-check-out|payment-return|confirm)\/?$/
const USER_ZONE_PATH = /\/user-zone(?:\/|$)/

/** Checkout y retorno 3DS: sin CMP (iframes de Stripe). */
export function isStripePaymentPath(path: string): boolean {
  return STRIPE_PAYMENT_PATH.test(path)
}

export function isCheckoutFlowPath(path: string): boolean {
  return CHECKOUT_FLOW_PATH.test(path)
}

export function isUserZonePath(path: string): boolean {
  return USER_ZONE_PATH.test(path)
}

/** Checkout, confirmación y zona de usuario: sin banner CMP. */
export function isCmpSuppressedPath(path: string): boolean {
  return isCheckoutFlowPath(path) || isUserZonePath(path)
}

export function checkoutVisitFingerprint(input: {
  hotelId?: number | string | null
  roomId?: number | string | null
  date?: string | null
  packHours?: number | null
}): string {
  return [input.hotelId ?? '', input.roomId ?? '', input.date ?? '', input.packHours ?? ''].join('|')
}

export function parseCheckoutStartedKeys(raw: string | null): string[] {
  if (!raw) return []
  try {
    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((key): key is string => typeof key === 'string' && key.length > 0)
  } catch {
    return []
  }
}

/**
 * Primera visita a este checkout vs retorno (atrás, recovery o volver a reservar).
 * `abandonedCheckout` es el flag de salida sin comprar (`SESSION_CHECKOUT_PAGE_VISITED`).
 */
export function resolveIsReturnCheckoutVisit(input: {
  fingerprint: string
  startedKeys: string[]
  abandonedCheckout: boolean
}): { is_return_visit: boolean; nextStartedKeys: string[] } {
  const emptyFingerprint = !input.fingerprint || input.fingerprint === '|||'
  if (emptyFingerprint) {
    return {
      is_return_visit: input.abandonedCheckout,
      nextStartedKeys: input.startedKeys
    }
  }

  const seen = input.startedKeys.includes(input.fingerprint)
  return {
    is_return_visit: input.abandonedCheckout || seen,
    nextStartedKeys: seen ? input.startedKeys : [...input.startedKeys, input.fingerprint]
  }
}
